import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import styles from "../styles/loginContainer.module.css";
import commonStore from "../../Store/marco/commonStore";
import { ForgetPassword } from "../modals/ForgetPassword";
import { SubscriptionExpiredModal } from "../modals/SubscriptionExpiredModal";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useTranslation, Trans } from "react-i18next";
import LoginLoading from "./LoginLoading";
import { handleAPIError, MESSAGE_CODES } from "../../services/toast";
export const LoginContainer2 = observer(() => {
  const { t } = useTranslation("login");
  const [account, setAccount] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubscriptionExpired, setIsSubscriptionExpired] = useState(false);
  const [expireDate, setExpireDate] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("ssoError") !== "login_failed") return;

    handleAPIError(new Error(MESSAGE_CODES.SSO_LOGIN_FAILED), {
      scenarioCode: MESSAGE_CODES.SSO_LOGIN_FAILED,
      throwError: false,
      toastOptions: {
        toastId: "login-initialization-failed"
      }
    });
    window.history.replaceState(null, "", window.location.pathname);
  }, []);

  const handleLogin = async () => {
    setIsLoading(true);
    try {
      await commonStore.login(account, password);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      if (error && error.error_code === "FORBIDDEN") {
        setIsSubscriptionExpired(true);
        setExpireDate(error.data?.expire_date || "");
      }
    }
    // 注意：若登入成功，會觸發路由跳轉，元件會卸載，不需要手動設回 false
    // 若失敗 (例如 commonStore catch 住但沒 throw)，則需確保這裡能恢復狀態
    // commonStore.login 內部有 catch，所以這裡可能接不到 error。
    // 修正：commonStore.login 應該要在失敗時 throw error 或回傳 status
    // 或是我們簡單做一個 timeout 恢復 (不建議)，
    // 更好的做法是修改 commonStore 讓它失敗時拋出錯誤，或是在這裡判斷 token
    if (!commonStore.token) {
      setIsLoading(false);
    }
  };

  const _handleClick = () => {
    const urlToOpen =
      "https://south-east-asia.bureauveritas.com/bureau-veritas-south-east-asia/bureau-veritas-singapore";
    window.open(urlToOpen, "_blank");
  };

  if (isLoading) {
    return (
      <LoginLoading
        message="Signing in..."
        onBack={() => setIsLoading(false)}
      />
    );
  }

  return (
    <div className={styles.container}>
      <h4 className={styles.welcome}>{t("Welcome to NXMap®!")}</h4>
      <p className={styles.loginIntro}>
        {t("NXMapDescription")
          .split("Bureau Veritas")
          .map((part, index) => (
            <span key={index}>
              {part}
              {index < 1 && (
                <div
                  className={styles.bureauVeritasLink}
                  onClick={_handleClick}
                >
                  {"Bureau Veritas."}
                </div>
              )}
            </span>
          ))}

        {/* NXMap® is an enterprise-grade, collaborative, decarbonization platform
        which enables businesses and organizations to measure, track and reduce
        their greenhouse gas emissions at an organizational level. This platform
        is curated in accordance with the Greenhouse Gas Protocol methodology,
        ISO 14064-1 (organization level) and ISO14064-2 (project level)
        specification with guidance for quantification and reporting of
        greenhouse gas emissions and removals. It is an enabler for accurate
        environmental data disclosure and is assured by a leading global
        testing, inspection and certification company,{" "} */}
        {/* {t("NXMapDescription")} */}
        {/* <a
          href="https://south-east-asia.bureauveritas.com/bureau-veritas-south-east-asia/bureau-veritas-singapore"
          target="_blank"
          rel="noopener noreferrer"
        >
          Bureau Veritas.
        </a> */}
      </p>

      <div className={styles.main}>
        <div className={styles.loginForm}>
          <div className={styles.logo}>
            <img height={60} src="/NXMap-white-blue.png" alt="NXMap Logo" />
          </div>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleLogin();
            }}
            className={styles.inputWrap}
          >
            <label>
              {t("Email")}
              <input
                type="email"
                placeholder={t("Email")} 
                value={account}
                onChange={(e) => setAccount(e.target.value)}
              />
            </label>

            <label>
              {t("Password")}
              <input
                className={styles.passwordInput}
                type={showPassword ? "text" : "password"}
                placeholder={t("Password")}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <span
                className={styles.passwordToggle}
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </span>
            </label>

            <button type="submit" className={styles.loginBtn}>
              {t("Login")}
            </button>
          </form>

          <p
            className={styles.forgottenPsw}
            onClick={() => setIsOpen(true)}
            style={{ cursor: "pointer", marginTop: "12px" }}
          >
            {t("Forgotten Password?")}
          </p>
        </div>
      </div>

      {isOpen && <ForgetPassword setIsOpen={setIsOpen} />}
      {isSubscriptionExpired && (
        <SubscriptionExpiredModal
          expireDate={expireDate}
          onClose={() => setIsSubscriptionExpired(false)}
        />
      )}
    </div>
  );
});
